module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SelectMallCartView.js"));
	}, "SelectMallCartView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SelectMallCartView!./src/pages/Shop/Member/Personal/SelectMall/SelectMallCart/SelectMallCartView.js
// module id = 1940
// module chunks = 367